<div class="stick-top">
  <mat-toolbar><mat-icon>assignment</mat-icon> Applications</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/cmdbApplications/0">
      <mat-icon aria-label="Create a new CMDB application">add</mat-icon>
      Create a new Application
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Name<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Tag<input [(ngModel)]="filter.applicationTagName"></div></th>
      <th><div class="vbox">Business Criticality<input [(ngModel)]="filter.businessCriticality"></div></th>
      <th><div class="vbox">Operational Status<input [(ngModel)]="filter.operationalStatus"></div></th>
      <th><div class="vbox">Asset Tag<input [(ngModel)]="filter.assetTag"></div></th>
      <th><div class="vbox">Business Owner<input [(ngModel)]="filter.businessOwner"></div></th>
      <th><div class="vbox">Business Department<input [(ngModel)]="filter.businessDepartment"></div></th>
      <th><div class="vbox">IT Owner<input [(ngModel)]="filter.itOwner"></div></th>
      <th><div class="vbox">IT Department<input [(ngModel)]="filter.itDepartment"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/cmdbApplications/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.applicationTagName}}</td>
      <td>{{element.businessCriticality}}</td>
      <td>{{element.operationalStatus}}</td>
      <td>{{element.assetTag}}</td>
      <td><micro-contact-lookup [contactId]="element.businessOwnerId"></micro-contact-lookup></td>
      <td><micro-contactDepartment-lookup [contactDepartmentId]="element.businessDepartmentId"></micro-contactDepartment-lookup></td>
      <td><micro-contact-lookup [contactId]="element.itOwnerId"></micro-contact-lookup></td>
      <td><micro-contactDepartment-lookup [contactDepartmentId]="element.itDepartmentId"></micro-contactDepartment-lookup></td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
